export const SHOPPING_BASKET_SAMPLE_DATA = [
  {
    qty: 1,
    productName: 'Women\'s High-Rise Skinny Jeans',
    total: 19.99
  },
  {
    qty: 2,
    productName: 'Kid\'s Hoddie (Boys/Girls)',
    total: 29.98,
    pricePerUnit: '$14.99 ea'
  },
  {
    qty: 2,
    productName: 'Slip-On Sneakers (Men/Women)',
    total: 49.98,
    pricePerUnit: '$24.99 ea'
  },
  {
    qty: 1,
    productName: 'Baseball Cap',
    total: 7.98,
  },
];